import { BaseListService } from '@/modules/core/list/services/BaseListService';
import ClientCategoryResource from '@/modules/ta/client/resources/ClientCategoryResource';

class ClientCategoryService extends BaseListService {
  constructor() {
    super(ClientCategoryResource);
  }
}

export default new ClientCategoryService();
